/**
 * Global constants. You can define your constant and access it by importing this file in the component.
 */
export const GoogleAppGlobals = {
  GOOGLE_CLIENT_ID: ''
};
export const FacebookAppGlobals = {
  FACEBOOK_CLIENT_ID: ''
};
